import { render, staticRenderFns } from "./remoteSelect.vue?vue&type=template&id=648e4f2a&"
import script from "./remoteSelect.vue?vue&type=script&lang=js&"
export * from "./remoteSelect.vue?vue&type=script&lang=js&"
import style0 from "./remoteSelect.vue?vue&type=style&index=0&id=648e4f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports